import store from '@/store'

const plugins = []

/**
 * 注册一个礼包插件
 * @param {Object} plugin
 * @param {string} plugin.id          - 唯一 ID，也作为 Vuex module 名
 * @param {Object} plugin.store       - Vuex module 定义 { state, mutations, actions, getters }
 * @param {Object} plugin.component   - 渲染用的 Vue 组件
 * @param {number} [plugin.order=0]   - 渲染顺序（小的在前）
 */
export function registerGiftPlugin(plugin) {
  if (plugin.store) {
    store.registerModule(['gift', plugin.id], {
      namespaced: true,
      ...plugin.store,
    })
  }

  plugins.push(plugin)
  plugins.sort((a, b) => (a.order || 0) - (b.order || 0))
}

/**
 * 获取所有已注册的插件
 */
export function getGiftPlugins() {
  return plugins
}

/**
 * 初始化所有插件（加载数据）
 * @param {Object} context - 游戏上下文 { gameId, currency, locale, isMobile, listId }
 */
export async function initGiftPlugins(context) {
  const tasks = plugins.map((plugin) => {
    if (plugin.store && plugin.store.actions && plugin.store.actions.init) {
      return store.dispatch(`gift/${plugin.id}/init`, context).catch((err) => {
        console.error(`[Gift] Plugin "${plugin.id}" init failed:`, err)
      })
    }
  })
  await Promise.all(tasks.filter(Boolean))
}
